import {
  ValuesAdminLanguage,
  ValuesAdminLoginForm
} from '@modules/Authentication/Login/interfaces';

import BaseService from '@core/class/BaseService';

class AuthService extends BaseService {
  public adminLogin = (body: ValuesAdminLoginForm) => {
    return this.post('api/v1/admin/login', body);
  };

  public adminForwarderLogin = (body: ValuesAdminLoginForm) => {
    return this.post('api/v1/forwarding/login', body);
  };

  public sellerAdminLogin = (body: ValuesAdminLoginForm) => {
    return this.post('api/v1/seller/login', body);
  };

  public sellerApiLogin = (body: {
    email: string;
    password: string;
    userType: 'SELLER' | 'WAREHOUSE';
  }) => {
    return this.post('api/auth/login', body);
  };

  public warehouseAdminLogin = (body: ValuesAdminLoginForm) => {
    // return this.post("api/v1/seller/login", body);
    return this.post('api/v1/warehouse/login', body);
  };

  public storeManagerLogin = (body: ValuesAdminLoginForm) => {
    return this.post('company/auth/signin', body);
  };

  public adminLogout = () => {
    return this.post('api/v1/seller/login');
  };

  public storeManagerLogout = () => {
    return this.post('company/auth/logout');
  };

  public changeLanguage = (body: ValuesAdminLanguage) => {
    return this.patch('admin/change-language', body);
  };

  // public adminApiLogin = (body: ValuesAdminLoginForm) => {
  //   return this.post('', {
  //     email: body.email,
  //     password: body.password,
  //     userType: 'SELLER'
  //   });
  // };
}

export default new AuthService('/', false);
